

class SlotFormController

    ### @ngInject ###
    constructor: ($q, $scope, ModelService, ModelConfig) ->
        @q = $q
        @ModelService = ModelService
        @config = ModelConfig.getModelDatapoints('americorps_slot')

        getSlots(ModelService, @programId)
            .then @setGrantYears
            .then (years) => findSlotsForDate(years, @slot.amc_enrollment_date)
            .then @setSlots
            .then @setInitialSlot

        $scope.$watch (=> @slot?.slot?), (val) =>
            if not val then @setInitialSlot()

    Object.defineProperties @prototype,
        date: get: -> @form?.formData.amc_enrollment_date
        slotData:
            get: -> @form?.formData.slot
            set: (value) -> @form?.formData.slot = value

    setGrantYears: (grantYears) =>
        @grantYears = grantYears
        return grantYears

    setSlots: (slots) =>
        @slots = slots
        return slots

    setInitialSlot: =>
        fakeSlot = year: @slot.grant_year, type: @slot.slot_type
        @slot.slot = findSlotInList(fakeSlot, @slots)

    dateChanged: ->
        console.log arguments
        @setSlots(findSlotsForDate(@grantYears, @date))
        @slotData = findSlotInList(@slotData, @slots)
        return

    normalizeData: (data) ->
        data.slot_type = data.slot.type
        data.grant_year = data.slot.year
        delete data.slot
        return data

    save: (data) ->
        if not data.slot? then return @q.reject()
        data = @normalizeData(data)
        return @doSave(data)

    doSave: (data) ->
        return @ModelService.patchModel(@slot, data)
            .then @setInitialSlot

    close: ->
        @onClose()
        return


getSlots = (ModelService, @programId) ->
    ModelService.getRelation('program', @programId, 'initiatives/slots')


dateInYear = (date, year) ->
    return not date.isBefore(year.start_date) and date.isBefore(year.end_date)


findSlotsForDate = (grantYears, date) ->
    if not date?.isValid() then return []
    slots = []

    for year in grantYears
        if not dateInYear(date, year) then continue
        for slot in year.slots
            slots.push slot if slot.total > 0

    return slots

findSlotInList = (slot, slots) ->
    if not slot or not slots then return null
    for s in slots
        if isSameSlot(s, slot) then return s
    return null

isSameSlot = (slot1, slot2) ->
    slot1.year == slot2.year and slot1.type == slot2.type


class NewSlotFormController extends SlotFormController

    constructor: ($q, $scope, ModelService, ModelConfig) ->
        @slot = {}
        @startOpen = true
        @title = 'Add AmeriCorps Slot '
        super($q, $scope, ModelService, ModelConfig)

    doSave: (data) ->
        return @ModelService.postRelation(
            'participant', @participantId,'slots', data)

class NewMemberController extends SlotFormController

    constructor: ($q, $scope, ModelService, ModelConfig) ->
        @slot = {}
        @startOpen = true
        @showMemberName = true
        @title = 'Add AmeriCorps Member'
        super($q, $scope, ModelService, ModelConfig)

    doSave: (data) ->
        return @ModelService.postRelation(
            'program', @programId,
            'amc-members', data)


newAmericorpsSlotDirective = ->
    restrict: "E"
    templateUrl: 'students/americorps/americorpsSlotFormNew'
    scope: {}
    controller: NewSlotFormController
    controllerAs: 'ctrl'
    bindToController:
        participantId: '='
        programId: '='
        onClose: '&'


americorpsSlotFormDirective = ->
    restrict: 'E'
    templateUrl: 'students/americorps/americorpsSlotFormNew'
    scope:
        slot: '='
        programId: '='
        onClose: '&'
    controller: SlotFormController
    controllerAs: 'ctrl'
    bindToController: true


newMemberDirective = =>
    restrict: 'E'
    templateUrl: 'students/americorps/americorpsSlotFormNew'
    scope: {}
    controllerAs: 'ctrl'
    controller: NewMemberController
    bindToController:
        programId: '='
        onClose: '&'


module.directive 'dybNewAmericorpsSlotForm', newAmericorpsSlotDirective
module.directive 'dybAmericorpsSlotForm', americorpsSlotFormDirective
module.directive 'newAmericorpsMemberForm', newMemberDirective